import { HttpParams, httpResource } from '@angular/common/http';
import { computed, runInInjectionContext } from '@angular/core';
import { widgetHttpHeader } from 'scw-digital-boards-widgets';
import { actionTrackerContext } from '../../../../core/interceptors/api-interceptor.interceptor';
import { IBaseResponse } from '../../../../utilities/http-utilities.service';
import { IDropdownOption } from '../../mat-dropdown/mat-dropdown.component';
import { AdvancedFilterApiMatcher } from './advanced-filter-api-matcher';

export class BoardAdvancedFilterApiMatcher extends AdvancedFilterApiMatcher {
  public override idValidationResource = runInInjectionContext(this.injector, () =>
    httpResource<IBaseResponse<IDropdownOption>>(() => ({
      context: actionTrackerContext,
      method: 'GET',
      params: new HttpParams().set('fields', 'id,name'),
      reportProgress: true,
      headers: widgetHttpHeader,
      url: `boards/${this.id}`,
    })),
  );

  public override label = computed(() => {
    return this.idValidationResource.status() === 'resolved'
      ? (this.idValidationResource.value()?.data.name ?? '...')
      : '...';
  });
}
